import en from "./en";
import fr from "./fr";
import ru from "./ru";
import ky from "./ky";

export default {
  en: en,
  fr: fr,
  ru: ru,
  ky: ky,
};
